// Situacoes do marcador do exemplar no mapa (pins em /public/pins).
// Mesmo catalogo do servidor (cta_catalogs.MAP_PIN_STATES); um teste do backend
// falha se os dois divergirem. `applied: false` = catalogada, ainda sem dado no mapa.

export interface TreePinState {
  code: string;
  label: string;
  color: string;
  icon: string;
  rule: string;
  applied: boolean;
}

export const TREE_PIN_STATES: TreePinState[] = [
  { code: "RISCO_CRITICO", label: "Risco crítico", color: "#dc2626", icon: "/pins/risco-critico.png", rule: "Classe de risco CRITICO na última avaliação", applied: true },
  { code: "RISCO_ALTO", label: "Risco alto", color: "#f97316", icon: "/pins/risco-alto.png", rule: "Classe de risco ALTO na última avaliação", applied: true },
  { code: "RISCO_MEDIO", label: "Risco médio", color: "#eab308", icon: "/pins/risco-medio.png", rule: "Classe de risco MEDIO na última avaliação", applied: true },
  { code: "RISCO_BAIXO", label: "Risco baixo", color: "#16a34a", icon: "/pins/risco-baixo.png", rule: "Classe de risco BAIXO na última avaliação", applied: true },
  { code: "EM_AVALIACAO", label: "Em avaliação", color: "#2563eb", icon: "/pins/em-avaliacao.png", rule: "Exemplar cadastrado ainda sem avaliação de risco", applied: true },
  { code: "PODADO", label: "Poda registrada", color: "#6b8e23", icon: "/pins/podado.png", rule: "Intervenção de poda executada (aguarda o registro de intervenções)", applied: false },
];

const BY_CODE = new Map(TREE_PIN_STATES.map((s) => [s.code, s]));

/** Situacao do pin a partir da classe de risco da ultima avaliacao. */
export function treePinState(risco: string | null | undefined): TreePinState {
  const code = (risco ?? "").toUpperCase();
  return BY_CODE.get(`RISCO_${code}`) ?? BY_CODE.get("EM_AVALIACAO")!;
}
